module.exports = __webpack_public_path__ + "media/images/news/200411-eb6c744ac56d54f351c51881684e8ec2.jpg";